export default {
  title: "No Active Group Assigned",
  message:
    "Your account is active, but you are not currently assigned to any active savings group.",
  help:
    "Please contact a group administrator. After you are assigned, use the button below to check again.",
  refresh: "Check Again",
  checking: "Checking...",
  logout: "Logout",
  footer:
    "You can still sign in securely even when you are not yet assigned to a group.",

  errors: {
    stillNoGroup:
      "You are still not assigned to any active group.",
    tooManyAttempts:
      "Too many attempts. Please wait a minute, then try again.",
    checkFailed:
      "Failed to check your group membership. Please try again.",
  },
};
